import React, { useEffect, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import FilledInput from '@material-ui/core/FilledInput';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import Cookies from 'js-cookie';

import API_PATH from "../../constants/config.json";
import { setCookie } from '../../functions/Auth';
import { Container, CssBaseline } from '@material-ui/core';
import '../../scss/components/_user_details.scss';
import ErrorMessage from '../AppLayouts/ErrorMessage';

const axios = require('axios');
const API_URL = process.env.REACT_APP_BASE_URL;


const GroupDetails = (props) => {

    const [teamName, setTeamName] = React.useState('');
    const [description, setDescription] = React.useState('');
    const [privileges, setPrivileges] = React.useState([]);
    const [teamValues, setTeamValues] = React.useState({
        team_name: "",
        description: "",
    });
    const [errPopUp, setErrPopUp] = React.useState(false);
    const [errMsg, setErrMsg] = React.useState(null);
    const [errMsgType, setErrMsgType] = React.useState(null);
    const [loader, setLoader] = React.useState(false);
    const [initialTeamName, setInitialTeamName] = React.useState('');
    const [initialDescription, setInitialDescription] = React.useState('');
    const [msgTitle, setMsgTitle] = useState(null);
    const [errTeamName, setErrTeamName] = useState(null);
    const [errMsgNotEmpty, setErrMsgNotEmpty] = useState(null);

    useEffect(
        () => {
        getTeamDetails();
        }, []
    )

  //Start update team form validations code ...
    const validateForm = async e => {
        setErrMsg(null);
        e.preventDefault();
        if (teamValues.team_name == '') {
            setErrMsg('Team name required.');
            setErrPopUp(true);
        } else {
            updateTeamAPI();
        }
    }
  //End update team form validations code ...

    const ShowErrPopUp = () => {
        setErrPopUp(false)
    };

    const formHandleChange = name => event => {
        let val = event.target.value;
        if (name == 'team_name') {
            if(val === '') {
                setErrTeamName(true);
                setErrMsgNotEmpty('Group name cannot be empty');
            } else 
                setErrTeamName(false)
            setTeamName(event.target.value);
        } else if (name == 'description') {
        setDescription(event.target.value);
        }
        setTeamValues({ ...teamValues, [name]: event.target.value });
    }

  //This method is use for API call to get team details .... start
    const getTeamDetails = () => {
        try {
        axios({
            method: 'post',
            data: {
            "teamId": parseInt(sessionStorage.getItem('teamId')),
            },
            headers: {
            'payload': Cookies.get('payload'),
            'agencyid': sessionStorage.getItem('agency_id')
            },
            url: API_URL + API_PATH.getTeamInfo,
        })
            .then(async function (response) {
            if (response.status && response.status == '200') {
                props.setGroupName(response.data.data.team_name);
                setTeamName(response.data.data.team_name);
                setDescription(response.data.data.description);
                setPrivileges(response.data.data.privilage_desc)
                setInitialTeamName(response.data.data.team_name)
                setInitialDescription(response.data.data.description)
                setTeamValues({
                team_name: response.data.data.team_name,
                description: response.data.data.description,
                });
            } else {
                setTeamName('');
                setDescription('');
                setPrivileges([])
            }
            })
            .catch(function (error) {
            if (error.response) {
                setTeamName('');
                setDescription('');
                setPrivileges([])
            } else {
                setTeamName('');
                setDescription('');
            }
            })
        } catch (error) {
        console.error(error);
        }
    }

    const clearTeamForm = () => {
        setTeamName(initialTeamName);
        setDescription(initialDescription);
        setTeamValues({
        team_name: initialTeamName,
        description: initialDescription,
        });
    }
  //This method is use for API call to get team details .... End


  //This method is use for API call to update team information .... Start
    const updateTeamAPI = () => { 
        setErrMsg(null);
        setErrMsgType(null);
        setLoader(true);
        props.setNeedToReload(false);
        let data = { ...teamValues };
        try {
        axios({
            method: 'post',
            data: data,
            headers: {
            'payload': Cookies.get('payload'),
            'agencyid': sessionStorage.getItem('agency_id')
            },
            url: API_URL + `/api/v1/user/teaminfoupdate/${sessionStorage.getItem('teamId')}`,
        })
            .then(async function (response) {
            if (response.status && response.status == '200') {
                setErrMsgType('custom_success');
                setMsgTitle('Saved successfully');
                setErrMsg('--');
                setErrPopUp(true);
                props.setNeedToReload(true);
            } else {
                setErrMsgType('error')
                setErrMsg('Something went wrong');
                setErrPopUp(true)
                setLoader(false);
            }
            setLoader(false);
            })
            .catch(function (error) {
            if (error.response) {
                setErrMsgType('error')
                setErrMsg(error.response.data.message);
                setErrPopUp(true)
                setLoader(false);
            } else {
                setErrMsgType('error')
                setErrMsg('Something went wrong');
                setErrPopUp(true)
                setLoader(false);
            }
            })
        } catch (error) {
        console.error(error);
        setLoader(false);
        }
    }

    return (
        <React.Fragment>
            <CssBaseline />
            <div>
                <form className="group-details-form" noValidate autoComplete="off" onSubmit={e => validateForm(e)}>
                    <Grid container spacing={3} className="margin-0">
                        {/* Group Details */}
                        <Grid item xs={6} className="padding-right-24 vertical-divisor padding-left-side">
                            <label>Group details</label>
                            <p>Information on the permissions of this group</p>
                            {errMsg ? <ErrorMessage title={msgTitle} message={errMsg} visible={ShowErrPopUp} show={errPopUp} msgType={errMsgType} /> : null}
                            <Grid container spacing={1} >
                                <Grid xs={12} item>
                                <Paper className="paper" >
                                    <p className="text-input-label">Group name</p>
                                    <FilledInput 
                                    id="team_name" 
                                    className={errTeamName ? "form-text-input-error" : "form-text-input"} 
                                    type="text" variant="outlined" required 
                                    value={teamName} 
                                    onChange={formHandleChange('team_name')}
                                    data-testid='first_name'  
                                    endAdornment={ errTeamName && <FontAwesomeIcon icon={faExclamationCircle} className="end-error-icon" /> } 
                                    />
                                    {errTeamName ? <p className="form-error-label">{errMsgNotEmpty}</p> : null}
                                </Paper>
                                </Grid>
                                <Grid xs={12} item style={{position: 'relative'}}>
                                    <Paper className="paper" >
                                        <p className="text-input-label">Group description</p>
                                        <TextareaAutosize
                                            id="team_desc" 
                                            className="form-text-area"
                                            rowsMin={3}
                                            value={description} 
                                            onChange={formHandleChange('description')}
                                            data-testid='team_descriptipn'  
                                        />
                                    </Paper>
                                    <label className="optional-lbl">Optional</label>
                                </Grid>
                            </Grid>
                        </Grid>
                        {/* Privileges */}
                        <Grid item xs={6} className="padding-left-24 padding-right-side">
                            <label>Privileges</label>
                            <p>Users assigned to this group can:</p>
                            <ul>
                                {privileges.map((value, index) => {
                                    return <li>{value}</li>
                                })}
                            </ul>
                        </Grid>
                        <Grid xs={12} item className="no-padding-bottom">
                            <Paper className="paper" style={{ textAlign: 'right' }} >
                                <Button type="reset" variant="outlined" id="cancel_btn1" data-testid="cancel_pwd_btn" className="cancel-btn" onClick={() => props.setShowGroupTabs(false)}>
                                Cancel</Button>&nbsp;&nbsp;
                                <Button 
                                    type="submit" 
                                    variant="outlined" 
                                    id="save_btn1" 
                                    data-testid="save_pwd_btn" 
                                    className="blue-btn font-14"
                                    disabled={ teamName === '' ? true : false}
                                >
                                Save</Button>
                            </Paper>
                        </Grid>
                    </Grid>
                </form>
            </div>
        </React.Fragment>
    )
}

export default GroupDetails;